export default "__VITE_ASSET__CvsnSdPa__"